import { useEffect } from "react";
import ReactGA from 'react-ga4';
import { useLocation } from "react-router-dom";

export function usePageTrack() {
    const location = useLocation();

    useEffect(() => {
        //console.log(window.location.pathname + window.location.search)
        ReactGA.send({ hitType: "pageview", page: location.pathname });
    //}, []);
    }, [location.pathname]);
};